// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#terminate[data-v-5bebbd64]{max-width:740px;margin-left:auto;margin-right:auto}#terminate .message p[data-v-5bebbd64]:last-child{margin:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
